module.exports = __webpack_public_path__ + "static/media/full-spa-body-massage.76031dfa.webp";